import axios from 'axios'
import base from '../../base'
import resource from './resource'
import { LOAD_MENU, USER_INFO, GET_INSTITUICOES } from './mutation-types'

const LOCALSTORAGE_KEY = 'imea.portal.userinfo'

export default {
  requestData({ commit }) {
    const config = {
      url: resource,
      baseURL: base,
      params: { all: 1 }
    }

    return axios(config).then(({ data }) => {
      const cadeias = []
      data.Result.forEach(cadeia => {
        if (cadeia.Id < 11) {
          cadeias.push({
            id: cadeia.Id,
            nome: cadeia.Nome,
            params: { cadeia: cadeia.Param }
          })
        }
      })
      commit(LOAD_MENU, cadeias)
    })
  },

  requestUserInfo({ commit }) {
    const config = {
      url: '/account/userinfo',
      baseURL: base
    }

    return axios(config).then(({ data }) => {
      commit(USER_INFO, data)
      window.localStorage.setItem(LOCALSTORAGE_KEY, JSON.stringify(data))
    })
  },

  requestInstituicoes({ commit }) {
    const config = {
      url: '/instituicao/usuario',
      baseURL: base
    }

    return axios(config).then(({ data }) => {
      commit(GET_INSTITUICOES, data)
    })
  }
}
